module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1000.fcd8ac06.jpg";